import { Grid, Typography } from '@mui/material'
import { Box, Container } from '@mui/system'
import React from 'react'
import ReactCompareImage from 'react-compare-image'
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { Brush, Downloading } from '@mui/icons-material';
// import { styled, keyframes } from '@mui/system';
import { keyframes } from '@mui/system';
import { useTheme } from '@emotion/react'



const pulse = keyframes`
    0% {
        box-shadow: 0 0 4px 2px #9ca7ff57;
    }
    33.3% {
        box-shadow: 0 0 14px 6px #909eff;
    }
   
    100% {
        box-shadow: 0 0 4px 2px #9ca7ff57;
    }
`

const pageload = keyframes`
	from {
		opacity: 0;
		transform: translateX(-100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`

const pageloadright = keyframes`
	from {
		opacity: 0;
		transform: translateX(100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`
const paraload = keyframes`
	from {
		opacity: 0;
		transform: translateY(100px);
   	}
   to {
		opacity: 1;
		transform: translate(0px);
   }
`

const Timeline = () => {
    const theme = useTheme()
    return (
        <div>
            <Container sx={{ py: 2, mt: { xs: 5, lg: 0 } }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                        <Grid item xs={5} sx={{ overflow: "hidden" }}>
                            <Box>
                                <Typography color={"primary.contrastText"} fontWeight={400} sx={{ lineHeight: "38px", animation: `${pageload} 1200ms ease 500ms backwards`, fontSize: { xs: "22px", sm: "28px", xl: "32px", } }}>Upload your images</Typography>
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <Typography color={"primary.contrastText"} sx={{ fontWeight: 300, fontSize: 15, animation: `${paraload} 1200ms ease 500ms backwards`, }}>Simply drag and drop your photos to submit a project in seconds. We accept every photo from IPhones to DSLRs.</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            {/* <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", borderRadius: "50%", width: "20px", height: "20px", marginLeft: "auto", marginRight: "auto" }}></Box> */}
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                            <Box sx={{ textAlign: "center", marginTop: "10px", }}>
                                <CloudUploadOutlinedIcon sx={{ backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, padding: "10px", borderRadius: "50%", animation: `${pulse} 2s infinite`, }}></CloudUploadOutlinedIcon>
                            </Box>
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", marginTop: "10px", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Box bgcolor={theme.palette.mode === "dark" ? "background.sidebar" : "background.sidebar"} sx={{ padding: "15px", borderRadius: "10px" }}>
                                <Box sx={{ borderRadius: "6px", overflow: "hidden", width: "100%", height: "250px" }}>
                                    <img src={process.env.PUBLIC_URL + "/assets/upload2.PNG"} alt="" style={{ objectFit: "cover", width: "100%", height: "250px", objectPosition: "top" }} />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ flexGrow: 1, marginTop: "-18px !important" }}>
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                        <Grid item xs={5}>
                            <Box bgcolor={theme.palette.mode === "dark" ? "background.sidebar" : "background.sidebar"} sx={{ padding: "15px", borderRadius: "10px" }}>
                                <Box sx={{ borderRadius: "6px", overflow: "hidden", width: "100%", height: "250px" }}>
                                    <img src={process.env.PUBLIC_URL + "/assets/select_edit_image.png"} alt="" style={{ objectFit: "cover", width: "100%", height: "250px", objectPosition: "top" }} />
                                </Box>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                            <Box sx={{ textAlign: "center", marginTop: "10px", }}>
                                <Brush color='primary' sx={{ backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, padding: "10px", borderRadius: "50%", animation: `${pulse} 2s infinite`, animationDelay: "2s" }}></Brush>
                            </Box>
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", marginTop: "10px", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                        </Grid>
                        <Grid item xs={5} sx={{ overflow: "hidden" }}>
                            <Box>
                                <Typography color={"primary.contrastText"} fontWeight={400} sx={{ lineHeight: "38px", animation: `${pageloadright} 1200ms ease 500ms backwards`, animationDelay: "2s", fontSize: { xs: "22px", sm: "28px", xl: "32px", } }}>Let us edits your images</Typography>
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <Typography color={"primary.contrastText"} sx={{ fontWeight: 300, fontSize: 15, animation: `${paraload} 1200ms ease 500ms backwards`, animationDelay: "2s" }}>We will enhance your hdr photos with the latest post processing and retouching techniques.</Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box sx={{ flexGrow: 1, marginTop: "-18px !important" }}>
                    <Grid container spacing={2} sx={{ alignItems: "center" }}>
                        <Grid item xs={5} sx={{ overflow: "hidden" }}>
                            <Box>
                                <Typography color={"primary.contrastText"} fontWeight={400} sx={{ lineHeight: "38px", animation: `${pageload} 1200ms ease 500ms backwards`, animationDelay: "3s", fontSize: { xs: "22px", sm: "28px", xl: "32px", } }}>Get your processed images</Typography>
                            </Box>
                            <Box sx={{ mt: 2 }}>
                                <Typography color={"primary.contrastText"} sx={{ fontWeight: 300, fontSize: 15, animation: `${paraload} 1200ms ease 500ms backwards`, animationDelay: "3s" }}>We can process any type of real estate photography and deliver in all formats including high resolution print and MLS.</Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                            <Box sx={{ textAlign: "center", marginTop: "10px", }}>
                                <Downloading color='primary' sx={{ backgroundColor: theme.palette.mode === "dark" ? 'background.card' : 'background.card', color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, padding: "10px", borderRadius: "50%", animation: `${pulse} 2s infinite`, animationDelay: "4s" }}></Downloading>
                            </Box>
                            <Box sx={{ background: "linear-gradient(55deg, rgba(167,197,223,1) 0%, rgba(118,191,255,1) 100%);", marginTop: "10px", width: "2px", height: "120px", marginLeft: "auto", marginRight: "auto" }}></Box>
                        </Grid>
                        <Grid item xs={5}>
                            <Box bgcolor={theme.palette.mode === "dark" ? "background.sidebar" : "background.sidebar"} sx={{ padding: "15px", borderRadius: "10px" }}>
                                <Box sx={{ borderRadius: "6px", overflow: "hidden" }}>
                                    <ReactCompareImage leftImage="https://sgoits-resized.s3.ap-southeast-1.amazonaws.com/low/azutt/tour/2023/03/AZUTT120/images/3 Page Point-227.jpg" rightImage="https://sgoits.s3.ap-southeast-1.amazonaws.com/azutt/tour/2023/03/AZUTT120/images/3 Page Point-227.jpg" />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </div >
    )
}

export default Timeline